/**
 * Inbox route — thin route composing the EingangScreen (T5 mail-split).
 * Supersedes the M1 InboxSplitView skeleton.
 *
 * [Source: docs/stories/t5-eingang-kommunikation-mailsplit.md]
 * [Source: docs/architecture/frontend-architecture.md#2-routing-spa-client-side]
 */

import { EingangScreen } from '../features/communication-v2/EingangScreen';

export function InboxPage() {
  return <EingangScreen />;
}
